import i18next from "i18next";
import { Details } from "../types/Details.type";

export const getItemToFlatList = (title: string, value: string | number) => {
  return {
    title,
    value,
  };
};
